///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Observable, Observer, Subscription } from 'rxjs';
import { filter, share } from 'rxjs/operators';
import { PreloaderService } from './preloader.service';
import { GtthStepGroupEnum } from '../generated/shared-types.model';

export type CustomEventName =
    | 'togglePreloaderModal'
    | 'gtthApp.httpError'
    | 'projectModified'
    | 'folderModified'
    | 'closeModalWindow'
    | 'projectClosed'
    | 'unitConfigShow'
    | 'unitConfigHide'
    | 'updateConfigShow'
    | 'changeProjectStep'
    | 'actionModeChanged'
    | 'nodeMove'
    | 'productServiceListModification'
    | 'productRadioListModification'
    | 'productAccessoryListModification'
    | 'engineRadioChange';

export interface CustomEvent {
    name: CustomEventName;
    eventObject?: {
        isShow: boolean;
    };
    content?: any;
    entityId?: any;
    modifyCommand?: any;
    stepNumber?: GtthStepGroupEnum;
    id?: any;
}

@Injectable({
    providedIn: 'root'
})
export class GtthEventManager {
    public static readonly NODE_MOVE_EVENT: CustomEventName = 'nodeMove';

    observable: Observable<CustomEvent>;
    observer: Observer<CustomEvent>;

    constructor(private readonly preloaderService: PreloaderService) {
        this.observable = new Observable((observer: Observer<CustomEvent>) => {
            this.observer = observer;
        }).pipe(share());
    }

    broadcast(event: CustomEvent) {
        if (this.observer != null) {
            this.observer.next(event);
        }

        // Event name 'togglePreloaderModal' checks here temporarily. The broadcast approach will remove soon
        if (event.name && event.name === 'togglePreloaderModal') {
            if (event.eventObject?.isShow) {
                this.preloaderService.show();
            } else {
                this.preloaderService.hide();
            }
        }
    }

    getEventSubscription(eventName: CustomEventName): Observable<CustomEvent> {
        return this.observable.pipe(
            filter((event) => {
                return event.name === eventName;
            })
        );
    }

    destroy(subscriber: Subscription): void {
        subscriber.unsubscribe();
    }
}
